import { Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import CustomTabPanel from "components/atoms/CustomTabPanel";
import React from "react";
import { useThemeCtx } from "store/contextStore/theme/ThemeStore";

import SampleStandards from "./sampleStandards";
import HmoList from "./hmoList";

const navItems = [
  {
    label: "Sample Standards",
    id: 0,
    component: <SampleStandards />,
  },
  {
    label: "HMO List",
    id: 1,
    component: <HmoList />,
  },
];

function More() {
  const { state } = useThemeCtx();
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={4}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "800", fontSize: "28px" }}>
          More
        </Typography>

        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
          variant="scrollable"
          scrollButtons={"auto"}
          allowScrollButtonsMobile
          indicatorColor="secondary"
          sx={{
            overflow: "hidden !important",

            "& .MuiTabs-indicator": {
              bgcolor: state.lightTheme ? "black" : "white",
            },
            "& .MuiTab-root.Mui-selected": {
              color: "text.primary",
            },
          }}
        >
          {navItems.map((item) => (
            <Tab
              key={item.id}
              component="a"
              onClick={(event) => {
                event.preventDefault();
                setValue(item.id);
              }}
              label={item.label}
            />
          ))}
        </Tabs>
      </Paper>

      <Paper sx={{ p: 2, minHeight: "70vh" }}>
        {navItems.map((nav) => (
          <CustomTabPanel
            key={nav.label}
            value={value}
            index={nav.id}
            boxSx={{ p: 0 }}
          >
            {nav.component}
          </CustomTabPanel>
        ))}
      </Paper>
    </Stack>
  );
}

export default More;
